import jwt_decode from "jwt-decode";

export const decodeToken = (token) => {
    const tokenData = jwt_decode(token);
    // localStorage.setItem('user', JSON.stringify(tokenData.data))
};
